<template>
  <div>
    <div class="d-flex align-items-center justify-content-between">
      <a
        class="d-flex btn pl-0"
        @click="
          ($parent.isExpand.assessmentScore =
            !$parent.isExpand.assessmentScore),
            $parent.checkExpandAll()
        "
      >
        <span class="pr-1">
          <i
            class="text-primary fas"
            :class="
              $parent.isExpand.assessmentScore
                ? 'fa-angle-down'
                : 'fa-angle-right'
            "
          />
        </span>
        <h5 class="text-primary text-left">Assessment Score</h5>
      </a>
    </div>

    <div v-if="$parent.isExpand.assessmentScore" class="gray-box">
      <p v-if="!profile?.assessment_test_details" class="text-center py-3 text-muted h6">
        No Assessment Score Found
      </p>
      <div v-else>
        <CRow class="profileView">
          <CCol col="5" class="text-gray font-13">Level</CCol>
          <CCol lg="7" class="text-black">
            {{ profile?.assessment_test_details?.level || "N/A" }}
          </CCol>
        </CRow>
        <CRow class="profileView">
          <CCol lg="5" class="text-gray font-13">Score</CCol>
          <CCol lg="7" class="text-black">
            {{
              profile?.assessment_test_details?.test_result_percentage || "0%"
            }}
          </CCol>
        </CRow>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    profile: {
      type: Object,
      default: () => null,
    },
  },
};
</script>
